import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import {
  Mall,
  Grade,
  Group,
  GetAccumulationsPaymentsPaymentNoRequest,
  DeleteAccumulationsPaymentsRequest,
  PostAccumulationsPaymentsRequest,
  PostAccumulationsPaymentsRequestValidation,
  GetMemberGradesRequest,
  GetMemberGroupsRequest,
  PutAccumulationsPaymentsPaymentNoRequest,
  GetMembersRequest,
} from 'supporter';
import { addDay, isBeforeTime, momentAdd } from '@/utils/dateUtils';
import { ncpPopup } from '@/utils/ncp';
import { MallsArrItem } from '@/types';
import { ExcelBulkRegistrationCallback } from '@/types/promotion';

@Component
export default class Modify extends Vue {
  @State public view!: object;

  @State('malls', { namespace: 'mall' })
  public malls!: Mall[];

  @State('popupData', { namespace: 'popup' })
  public popupData!: string;

  public paymentYmdt: string = addDay(new Date(), 0);
  public paymentCalendarOption = {
    dateType: 'YmdH',
    name: 'payment',
    fromRanges: addDay(new Date(), 0),
    endDate: false,
  };
  public notificationYmdt: string = addDay(new Date(), 0);
  public notificationCalendarOption = {
    dateType: 'YmdH',
    name: 'notification',
    fromRanges: addDay(new Date(), 0),
    endDate: false,
    onOpen: this.setStyle,
    onClose: this.resetStyle,
  };
  public setStyle() {
    $('#notificationForm').css({ height: $('#notificationForm').height() + 100 });
  }
  public resetStyle() {
    $('#notificationForm').css({ height: $('#notificationForm').height() - 100 });
  }
  public pickerFlag: boolean = false;

  public isModify: boolean = false;
  public showCancle: boolean = false;
  public notValid: boolean = true;
  public setNotification: boolean = false;
  public validYear: number = 0;
  public validMonth: number = 0;
  public totalValidMonth: number = 0;
  public checkAll: boolean = true;
  public overTime: boolean = false;
  public change: boolean = false;
  public eligibilitySet: boolean = false;
  public theAmount: any = '';
  public theTargetCount: number = 0;
  public validYearSelect: any[] = [
    { option: '0', value: 0 },
    { option: '1', value: 1 },
    { option: '2', value: 2 },
    { option: '3', value: 3 },
    { option: '4', value: 4 },
    { option: '5', value: 5 },
  ];
  public validMonthSelect: any[] = [
    { option: '0', value: 0 },
    { option: '1', value: 1 },
    { option: '2', value: 2 },
    { option: '3', value: 3 },
    { option: '4', value: 4 },
    { option: '5', value: 5 },
    { option: '6', value: 6 },
    { option: '7', value: 7 },
    { option: '8', value: 8 },
    { option: '9', value: 9 },
    { option: '10', value: 10 },
    { option: '11', value: 11 },
  ];

  public theModifyData: any = {
    amount: null,
    excludeMemberNos: Array(0),
    immediately: true,
    mallNo: 0,
    no: 89,
    notificationChannels: ['EMAIL', 'SMS'],
    notificationDateTime: '2020-05-07 00:00:00',
    notificationStatus: 'WAITING',
    paymentCount: 0,
    paymentDateTime: '',
    reason: '',
    registerAdminName: 'KL',
    registerAdminNo: 5524,
    registerDateTime: '2020-04-22 18:01:44',
    requestDateTime: '2020-04-30 00:00:00',
    rowKey: 0,
    rowSpanMap: {},
    sortKey: 0,
    status: 'WAITING',
    targets: [{ values: [0], type: 'ALL' }],
    uniqueKey: '@dataKey1587602557043-0',
    updateAdminName: 'KK',
    updateAdminNo: 1,
    updateDateTime: '2020-04-30 00:00:00',
    validPeriod: 12,
    viewDetail: 0,
  };
  public initNotificationChannels: string[] = ['EMAIL', 'SMS'];

  public targetTypeAll: boolean = false;
  public theTargets: any = [];
  public allTargets: any = 0;
  public memberInfo: any = {
    values: [],
    type: 'MEMBER_NO',
  };
  public targetType: any = 'ALL';
  public excludeNum: number = 0;
  public excludeMembers: any = [];
  public pickerChangeFlag: boolean = false;
  public initTargetInfo: any = [];
  public noticeTimeFlag: boolean = false;

  public isNumber: boolean = false;
  public isOutMax: boolean = false;
  public isCompanyName: boolean = false;

  public created(): void {
    this.checkModify();
    this.pickerFlag = false;
  }
  public mounted(): void {
    this.getTheMalls();
  }
  public init(): void {
    this.validYear = Math.floor(this.theModifyData.validPeriod / 12);
  }
  public changeRoute(name: string): void {
    this.$router.push(`/${name}`);
  }
  public handleMallChange(): void {
    $('#paymentTargets').val('');
    this.targetTypeAll = false;
    this.theTargetCount = 0;
  }
  public handleMemberSelect(): void {
    if (this.checkMallNo()) {
      const mallNo = this.theModifyData.mallNo;
      const title: any = this.$t('ACCUMULATION_PAYMENT_REQUEST_MEMBER_SELECT_POPUP_TITLE');
      (window as any).callback = this.callback;
      let idName = 'paymentTargets';
      ncpPopup(`/member/target/popup?mallNo=${mallNo}&callback=callback&target=${idName}`, title, 635, 460);
    }
  }
  public callback(data: any): void {
    let value: any = JSON.stringify(data);
    $('#paymentTargets').val(value);
    this.theTargets = data;
    this.targetType = 'GRADE_GRUOP';
    const gradeNos = data.GRADE;
    const groupNos = data.GROUP;

    if (gradeNos[0] !== '-1' && groupNos[0] !== '-1') {
      let request: GetMembersRequest = {
        params: {
          mallNo: this.theModifyData.mallNo,
          page: 1,
          pageSize: 100000,
        },
      };
      request.params.gradeNos = gradeNos.join(',');
      request.params.groupNos = groupNos.join(',');
      this.$api.getMembers(request).then(({ data }): void => {
        this.theTargetCount = data.totalCount;
      });
    }
    if (data.GRADE[0] !== '-1' && data.GROUP[0] === '-1') {
      const request: GetMemberGradesRequest = {
        params: {
          mallNo: this.theModifyData.mallNo,
          countMember: true,
        },
      };
      this.$api.getMemberGrades(request).then(({ data }): void => {
        const gradeTotalCount = this.getMemberTotalCount(data, gradeNos);
        this.theTargetCount = gradeTotalCount;
      });
    }
    if (data.GRADE[0] === '-1' && data.GROUP[0] !== '-1') {
      const request: GetMemberGroupsRequest = {
        params: {
          mallNo: this.theModifyData.mallNo,
          countMember: true,
        },
      };
      this.$api.getMemberGroups(request).then(({ data }): void => {
        const groupTotalCount = this.getMemberTotalCount(data, groupNos);
        this.theTargetCount = groupTotalCount;
      });
    }
    (window as any).callback = undefined;
  }
  public memberCallBack(res: any): void {
    this.targetType = 'MEMBER_NO';
    this.memberInfo = {
      values: [],
      type: 'MEMBER_NO',
    };
    this.theTargetCount = res.memberCount || 0;
    this.memberInfo.values = [];
    res.selectedMembers.forEach((item: any): any => {
      this.memberInfo.values.push(item.memberNo);
    });
    this.theModifyData.targets.map((item: any): any => {
      if (item.type === 'MEMBER_NO') {
        item.values = this.memberInfo.values;
      }
    });
  }
  private excelCallback({ memberCount, selectedMembers }: ExcelBulkRegistrationCallback): void {
    this.targetType = 'MEMBER_NO';
    this.memberInfo = {
      values: selectedMembers,
      type: 'MEMBER_NO',
    };
    this.theModifyData.targets = [this.memberInfo];
    this.theTargetCount = memberCount;
  }
  public excludeCallBack(res: any): void {
    this.excludeNum = res.memberCount;
    this.excludeMembers = [];
    res.selectedMembers.forEach((item: any): any => {
      this.excludeMembers.push(item.memberNo);
    });
  }
  public handleTargets(): any {
    let arr: any = [];
    if (this.targetType === 'MEMBER_NO') {
      arr.push(this.memberInfo);
    } else if (this.targetType === 'GRADE_GRUOP') {
      if (this.theTargets.GRADE[0] !== '-1') {
        let grade: any = {
          type: 'GRADE',
          values: this.theTargets.GRADE,
        };
        arr.push(grade);
      }
      if (this.theTargets.GROUP[0] !== '-1') {
        let group: any = {
          type: 'GROUP',
          values: this.theTargets.GROUP,
        };
        arr.push(group);
      }
    } else {
      let all: any = {
        values: [0],
        type: 'ALL',
      };
      arr.push(all);
    }
    return arr;
  }
  public getMemberTotalCount(info: (Grade | Group)[], list: number[]): number {
    return info
      .filter(({ no }) => list.includes(no))
      .map(({ memberCount }) => memberCount)
      .reduce((acc, cur) => acc + cur);
  }
  public getAllTargets(): void {
    let request = {
      params: {
        mallNo: this.theModifyData.mallNo,
        page: 1,
        countMember: true,
      },
    };
    this.$api.getMembers(request).then(({ data }): void => {
      this.theTargetCount = data.totalCount;
    });
  }
  public handleMemberSearch(): void {
    if (this.checkMallNo()) {
      const mallNo = this.theModifyData.mallNo;
      const title: any = this.$t('ACCUMULATION_PAYMENT_REQUEST_MEMBER_SEARCH_POPUP_TITLE');
      (window as any).memberCallBack = this.memberCallBack;
      ncpPopup(`/member/list/popup/${mallNo}?callback=memberCallBack`, title, 1275, 980);
    }
  }
  public handleMemberExclude(): void {
    if (this.checkMallNo()) {
      const mallNo = this.theModifyData.mallNo;
      const title: any = this.$t('ACCUMULATION_PAYMENT_REQUEST_MEMBER_SEARCH_POPUP_TITLE');
      (window as any).excludeCallBack = this.excludeCallBack;
      ncpPopup(`/member/list/popup/${mallNo}?callback=excludeCallBack`, title, 1275, 980);
    }
  }
  public handleExcelClick(): void {
    if (!this.checkMallNo()) {
      return;
    }
    const title = this.$t('ACCUMULATION_PAYMENT_REQUEST_EXCEL_BATCH_REGISTRATION_TITLE');
    (window as any).excelMembersCallBack = this.excelCallback;
    const popupUrl = `/popup/excel-batch-registration?mallNo=${this.theModifyData.mallNo}&callback=excelMembersCallBack`;
    ncpPopup(popupUrl, title as string, 900, 450);
  }

  public checkMallNo(): any {
    if (this.theModifyData.mallNo === 0) {
      alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_ADD_MALL_NO'));
      $('select[id="mallNo"]').focus();
      return false;
    }

    return true;
  }
  public paymentDetail(): void {
    const mallNo = this.theModifyData.mallNo;
    let mallName: any = '';
    this.malls.map((item: any): any => {
      if (item.mallNo === mallNo) {
        mallName = item.mallName;
      }
    });
    const requestNo = this.$route.query.requestNo;
    const title: any = this.$t('ACCUMULATION_PAYMENT_DETAIL_VIEW_POPUP_TITLE');
    ncpPopup(
      `/accumulation/popup/paymentList?mallName=${mallName}&mallNo=${mallNo}&requestNo=${requestNo}`,
      title,
      1000,
      700,
    );
  }
  public inputChange(e: any): void {
    let reg = /^[0-9,]+$/;
    if (!reg.test(e.target.value)) {
      this.isNumber = true;
      this.isOutMax = false;
    } else {
      this.isNumber = false;
      this.isOutMax = false;
    }
    this.theAmount = e.target.value.replace(/[^\d]/g, '');
    e.target.value = e.target.value.replace(/[^\d]/g, '');
    if (e.target.value !== '') {
      this.theAmount = Number(this.theAmount).toLocaleString();
    }
  }
  public inputWarnBlur(): void {
    this.isNumber = false;
  }
  public handleMountAlert(): void {
    if (this.theAmount === '0' || this.theAmount === '') {
      return;
    }
    if (this.removeComma(this.theAmount) % 10 > 0) {
      alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_PAYMENT_AMOUNT_ALERT'));
      this.theAmount = 0;
      return;
    }
    if (Number(this.theAmount.replace(/[^\d]/g, '')) > 999999900) {
      this.isNumber = false;
      this.isOutMax = true;
      this.theAmount = '';
    } else {
      this.isNumber = false;
      this.isOutMax = false;
    }
  }
  public removeComma(value: any): any {
    if (value) {
      return value.replace(/,/g, '');
    }
  }
  public keyupReasonChange(e: any): void {
    let reg = new RegExp(/[^a-zA-Z0-9ㄱ-힣\(\)\'\s]/g);
    if (reg.test(e.target.value)) {
      this.isCompanyName = true;
      this.theModifyData.reason = e.target.value.replace(/[^a-zA-Z0-9ㄱ-힣\(\)\'\s]/g, '');
      $('input[name="paymentReason"]').val(this.theModifyData.reason);
    }
  }
  public inputReasonWarnBlur(): void {
    this.isCompanyName = false;
  }
  public handleChange(reset?: boolean): void {
    this.change = !this.change;

    if (!reset) return;

    this.paymentYmdt = this.theModifyData.requestDateTime;
  }
  public checkOverTime(e: any): void {
    this.overTime = true;
    if (e.status === 'WAITING' && e.immediately === false) {
      let timeTempNow: number = new Date().getTime();
      let requestDateTimeTemp: number = Date.parse(e.requestDateTime);
      if (requestDateTimeTemp < timeTempNow) {
        this.overTime = true;
      } else {
        this.overTime = false;
      }
    }
  }
  public goBack(): void {
    this.$router.go(-1);
  }
  public cancelSub(): void {
    if (confirm(this.$t('ACCUMULATION_PAYMENT_REQUEST_PAYMENT_CANCEL_ALERT') as string)) {
      this.goBack();
    }
  }
  public deleteThePayment(): void {
    if (confirm(this.$t('ACCUMULATION_PAYMENT_REQUEST_PAYMENT_DELETE_COMFIRM') as string)) {
      const request: DeleteAccumulationsPaymentsRequest = {
        params: {
          mallNo: Number(parseInt(this.theModifyData.mallNo)),
        },
        pathParams: {
          paymentNo: this.$route.query.requestNo as any,
        },
      };
      this.$api.deleteAccumulationsPayments(request).then((): any => {
        alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_DELETE_SUCESS_ALERT') as string);
        // this.goBack();
        this.$router.push('/accumulation/payment');
      });
    }
  }
  public checkAllCheck(e: number): void {
    this.checkAll = e === 2; //NOTE : KAKAO 삭제
  }
  public handleCheckAll(): void {
    if (this.checkAll) {
      this.theModifyData.notificationChannels = [];
      this.theModifyData.notificationChannels = [...this.initNotificationChannels];
    } else {
      this.theModifyData.notificationChannels = [];
    }
  }

  public checkModify(): void {
    if (this.$route.query && this.$route.query.mode === 'modify') {
      this.isModify = true;
      this.searchPayment();
    } else {
      this.isModify = false;
      this.init();
    }
  }
  public calculateTotalValidMonth(): any {
    if (this.validYear === 0 && this.validMonth === 0) {
      if (this.theModifyData.validPeriod >= 12) {
        this.validYear = 1;
        this.theModifyData.validPeriod = this.validYear * 12 + this.validMonth;
      } else {
        this.validMonth = 1;
        this.theModifyData.validPeriod = this.validYear * 12 + this.validMonth;
      }
      alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_VALIDPERIOD_ATLEAST_ONE_YEAR_ALERT'));
      return;
    }
    this.theModifyData.validPeriod = this.validYear * 12 + this.validMonth;
  }

  public checkTheValid(): void {
    if (this.theModifyData && this.theModifyData.validPeriod !== 0) {
      this.notValid = false;
    } else {
      this.notValid = true;
    }
  }

  public checkTargetRadio(): void {
    this.targetTypeAll = this.theModifyData.targets.length > 0 && this.theModifyData.targets[0].type === 'ALL';
    if (this.theModifyData.targets.length > 0 && this.theModifyData.targets[0].type === 'MEMBER_NO') {
      this.theTargetCount = this.theModifyData.targets[0].values.length;
    }

    const getTarget = (targetType: 'GRADE' | 'GROUP'): any =>
      this.theModifyData.targets.find(({ type }: any): boolean => type === targetType);
    const targets: any = {
      GRADE: getTarget('GRADE')?.values ?? ['-1'],
      GROUP: getTarget('GROUP')?.values ?? ['-1'],
    };
    this.callback(targets);
  }

  public theMalls: MallsArrItem[] = [{ option: 'ACCUMULATION_PAYMENT_TOP_TBODY_STATUS_ALL', value: 0 }];
  public todayYmdtInit: string = momentAdd(new Date(), ['hour', 1], 'YYYY-MM-DD HH:00:00');

  public getTheMalls(): any {
    let resArr = this.malls.map((item: any): any => {
      return { option: item.mallName, value: item.mallNo };
    });
    this.theMalls = [{ option: 'ACCUMULATION_PAYMENT_TOP_TBODY_STATUS_ALL', value: 0 }, ...resArr];
  }
  public showChangeTarget(): void {
    this.showCancle = true;
  }
  public handleCancel(): void {
    this.showCancle = false;
    this.eligibilitySet = false;
    this.theTargetCount = 0;
    this.theModifyData.targets = this.initTargetInfo;
    this.checkTargetRadio();
  }
  public pickerChange(): void {
    if (!this.change && this.isModify) {
      return;
    }
    const nowTime = new Date().getTime();
    const notificationConfigPicker = this.$refs.notificationConfigPicker;
    const paymentTime = new Date(this.paymentYmdt.replace(/-/g, '/')).getTime();

    if (notificationConfigPicker) {
      const payDate = this.paymentYmdt.substring(0, 10);
      const notificationTime = this.notificationYmdt.substring(10);
      this.notificationYmdt = payDate + notificationTime;
    }

    if (this.setNotification && notificationConfigPicker) {
      if (!this.pickerChangeFlag) {
        this.pickerChangeFlag = true;
        return;
      }
    }
    if (paymentTime < nowTime) {
      if (!this.theModifyData.immediately) {
        alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_PAYMENT_TIME_SET_OLD_TIME_ALERT'));
      }
      this.$nextTick((): void => {
        this.paymentYmdt = this.todayYmdtInit;
      });
    }
  }

  public notificationChangeCheck(): void {
    if (this.setNotification) {
      const paymentTime = new Date(this.paymentYmdt.replace(/-/g, '/'));
      const notificationTime = new Date(this.notificationYmdt.replace(/-/g, '/'));

      if (this.theModifyData.immediately && isBeforeTime(this.notificationYmdt)) {
        alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_ADD_NOTIFICATION_TIME_CHECK'));
        this.$nextTick((): void => {
          this.notificationYmdt = this.todayYmdtInit;
        });
      }
      if (paymentTime > notificationTime && !this.theModifyData.immediately) {
        alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_ADD_NOTIFICATION_TIME_CHECK'));
        this.$nextTick((): void => {
          this.notificationYmdt = this.paymentYmdt;
        });
      }
    }
  }
  //////////////////////////////////////////////////////////post/////////////////////////////////////////////////////
  private isValidTarget() {
    if (this.targetTypeAll) {
      return true;
    }

    if (this.theTargetCount > 0) {
      return true;
    }

    if (Array.isArray(this.theTargets) && !this.theTargets.length) {
      return false;
    }

    const isEmptyGroup = this.theTargets.GROUP.some(group => Number(group) < 0);
    const isEmptyGrade = this.theTargets.GRADE.some(grade => Number(grade) < 0);

    return !(isEmptyGrade && isEmptyGroup);
  }
  public postAccumulationPayments(): void {
    if (!this.isValidTarget()) {
      alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_PAYMENT_TARGET_ALERT'));
      return;
    }

    let paymentRequest: PostAccumulationsPaymentsRequest = {
      data: {
        notificationRequestDate: this.setNotification ? this.notificationYmdt.substring(0, 10) : '',
        reason: this.theModifyData.reason,
        amount: this.theAmount === '' ? (null as any) : Number(this.theAmount.replace(/,/g, '')),
        paymentRequestHour: Number(this.paymentYmdt.substring(11, 13)),
        notificationChannels: this.setNotification ? this.theModifyData.notificationChannels : [],
        excludeMemberNos: this.excludeMembers,
        immediately: this.theModifyData.immediately,
        notificationRequestHour: this.setNotification ? Number(this.notificationYmdt.substring(11, 13)) : 0,
        mallNo: this.theModifyData.mallNo,
        targets: this.handleTargets(),
        validPeriod: this.notValid ? 0 : this.theModifyData.validPeriod,
        paymentRequestDate: this.paymentYmdt.substring(0, 10),
      },
    };
    let validation: any = PostAccumulationsPaymentsRequestValidation(paymentRequest, this.setNotification);
    if (validation.length > 0) {
      let errorField = validation[0].field;
      const message = validation[0].message;
      message !== 'ACCUMULATION_PAYMENT_REQUEST_PAYMENT_AMOUNT_ALERT_EMPTY' && alert(this.$t(message));

      switch (errorField) {
        case 'amount':
          $('input[name="paymentAccumulation"]').focus();
          break;
        case 'reason':
          $('input[name="paymentReason"]').focus();
          break;
      }
      return;
    }
    // 检查时间
    if (this.setNotification) {
      let paymentTemp: any = new Date(this.paymentYmdt.replace(/-/g, '/')).getTime();
      let notificationTemp: any = new Date(this.notificationYmdt.replace(/-/g, '/'));
      if (paymentTemp > notificationTemp) {
        alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_ADD_NOTIFICATION_TIME_CHECK'));
        return;
      }
    }

    this.$api.postAccumulationsPayments(paymentRequest).then((): any => {
      if (this.theModifyData.immediately) {
        alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_FINISH_POST_PAYMENT'));
      } else {
        alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_FINISH_POST_PAYMENT1'));
      }
      this.$router.push('/accumulation/payment');
    });
  }

  public handleCancelAdd(): void {
    if (confirm(this.$t('ACCUMULATION_PAYMENT_REQUEST_CANCEL_POST_PAYMENT') as string)) {
      this.$router.push('/accumulation/payment');
    }
  }
  //////////////////////////////////////////////////////save///////////////////////////////////////////////////////////
  public save(): void {
    let putRequest: PutAccumulationsPaymentsPaymentNoRequest = {
      pathParams: {
        paymentNo: this.theModifyData.no,
      },
      data: {
        notificationRequestDate: this.setNotification ? this.notificationYmdt.substring(0, 10) : '',
        reason: this.theModifyData.reason,
        amount: this.theAmount === '' ? (null as any) : Number(this.theAmount.replace(/,/g, '')),
        paymentRequestHour: Number(this.paymentYmdt.substring(11, 13)),
        notificationChannels: this.setNotification ? this.theModifyData.notificationChannels : [],
        excludeMemberNos: this.excludeMembers,
        immediately: this.theModifyData.immediately,
        notificationRequestHour: this.setNotification ? Number(this.notificationYmdt.substring(11, 13)) : 0,
        mallNo: this.theModifyData.mallNo,
        targets: this.handleTargets(),
        validPeriod: this.notValid ? 0 : this.theModifyData.validPeriod,
        paymentRequestDate: this.paymentYmdt.substring(0, 10),
      },
    };
    let validation: any = PostAccumulationsPaymentsRequestValidation(putRequest as any, this.setNotification);
    if (validation.length > 0) {
      alert(this.$t(validation[0].message));
      return;
    }

    if (this.theTargetCount === 0) {
      alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_PAYMENT_TARGET_ALERT'));
      return;
    }
    // 检查时间
    if (this.setNotification) {
      let paymentTemp: any = new Date(this.paymentYmdt.replace(/-/g, '/')).getTime();
      let notificationTemp: any = new Date(this.notificationYmdt.replace(/-/g, '/'));
      if (paymentTemp > notificationTemp) {
        alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_ADD_NOTIFICATION_TIME_CHECK'));
        return;
      }
    }
    this.$api.putAccumulationsPaymentsPaymentNo(putRequest).then((): any => {
      alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_MODIFY_SUCESS_ALERT'));
      this.$router.push('/accumulation/payment');
    });
  }

  ////////////////////////////////////////////////////////////////get/////////////////////////////////////////////////////

  public async searchPayment(): Promise<void> {
    let request: GetAccumulationsPaymentsPaymentNoRequest = {
      pathParams: {
        paymentNo: this.$route.query.requestNo as string,
      },
      params: {
        mallNo: Number(this.$route.query.mallNo),
      },
    };
    this.$api.getAccumulationsPaymentsPaymentNo(request).then(({ data }): void => {
      if (!data) {
        this.$router.go(-1);
      } else {
        this.theModifyData = {};
        this.theModifyData = data;
        this.initTargetInfo = [...data.targets];
        this.checkTheValid();
        this.checkTargetRadio();
        this.theAmount = this.theModifyData.amount.toLocaleString();
        if (this.theModifyData.excludeMemberNos.length > 0) {
          this.eligibilitySet = true;
          this.excludeNum = this.theModifyData.excludeMemberNos.length;
        }
        if (data.targets[0].type === 'MEMBER_NO') {
          this.targetType = data.targets[0].type;
          this.memberInfo.values = data.targets[0].values;
        }
        this.validYear = Math.floor(this.theModifyData.validPeriod / 12);
        this.validMonth = this.theModifyData.validPeriod % 12;
        this.setNotification = this.theModifyData.notificationChannels.length > 0 ? true : false;
        this.paymentYmdt = this.theModifyData.requestDateTime;
        if (this.theModifyData.immediately) {
          this.paymentYmdt = '00:00:00';
        } else {
          this.paymentYmdt = this.theModifyData.requestDateTime;
        }

        this.$nextTick((): any => {
          if (this.setNotification) {
            this.notificationYmdt = this.theModifyData.notificationDateTime;
            //NOTE: kakao 알림톡 삭제
            this.theModifyData.notificationChannels = data.notificationChannels.filter(channel=> channel !== 'KAKAO');
          } else {
            this.checkAll = true;
            this.theModifyData.notificationChannels = this.initNotificationChannels;
          }
        });

        this.checkOverTime(this.theModifyData);
      }
    });
  }
}
